import { useCurrenciesStore } from '@/stores';
import type { Currency } from '@/types/currencies';
import { symbolMap } from '@/utils/currencySymbols';
export const getCurrencyByCode = (code: string): Currency | { code: 'USD'; symbol: '$' } => {
    const currenciesStore = useCurrenciesStore();
    const currencies = currenciesStore.currencies;
    if (!currencies) {
        return { code: 'USD', symbol: '$' };
    }
    const currency = currencies.find((currency: Currency) => currency.code === code);
    if (!currency) {
        return { code: 'USD', symbol: '$' };
    }
    return currency;
};
export const sortCurrencies = (currencies: string[]): string[] => {
    return currencies.sort((a, b) => {
        // priority USD
        if (a === 'USD') return -1;
        if (b === 'USD') return 1;

        // priority EUR
        if (a === 'EUR') return -1;
        if (b === 'EUR') return 1;

        // alphabetical sorting for the rest
        return a.localeCompare(b);
    });
};
// Определяем функцию получения символа валюты
export const getCurrencySymbol = (currencyCode: string) => {
    if (symbolMap[currencyCode]) {
        return symbolMap[currencyCode];
    }

    try {
        const formatted = new Intl.NumberFormat('en', {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(1);

        const symbol = formatted.replace(/[\d\s.,]/g, '');
        return symbol || currencyCode;
    } catch {
        return currencyCode; // fallback
    }
};
